import getRequest from "../getRequest";

export default function pingAuthEducator() {
    // spins up the password cloud function
    const pingUrl = `https://us-central1-bellwork-cg1.cloudfunctions.net/authEducator3?ping=true`
    return getRequest(pingUrl).catch(err => console.log(err))
}


// WEBPACK FOOTER //
// ./src/helpers/users/pingAuthEducator.js